import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { confirmAlert } from 'react-confirm-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import axios from 'components/AppRequest';
import _ from 'lodash';
import visa from 'components/assets/img/logo/mono/visa.svg';
import mastercard from 'components/assets/img/logo/mono/mastercard.svg';
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';

class CardItems extends React.Component {

  state = {
    defaultState: true,
    customerCards: [],
    isLoading: true
  }

  componentDidMount() {
    if (this.props.isLogged) {
      this.fetchUserCards();
    } else if (this.props.isMyAccount) {
      this.fetchUserCards();
    }
  }

  transNotify = (key) => {
    return TransHelper.translate(this.props.locale, "content.notifications.cardItems." + key);
  }

  fetchUserCards = () => {
    axios.get('/pwa/cards/customer-cards')
      .then(response => {
        this.setState({
          customerCards: response.data.cards,
          isLoading: false
        });
      })
      .catch(err => {
        console.log('err', err)
      });
  }

  handleClick = (cardId) => {
    this.props.setCardId(cardId);
    if (!this.props.isMyAccount) {
      this.props.handleHideForm();
    }
  }

  removeCard = (cardId) => {
    this.setState({ isLoading: true }, () => {
      var params = { cardId: cardId };
      axios.post('/pwa/cards/remove-card', params)
        .then(response => {
          this.props.createSuccessNotification({
            message: this.transNotify('success')
          });
          this.props.setCardId(null);
          this.fetchUserCards();
        })
        .catch(err => {
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: this.transNotify('errorMessage')
          });
          this.fetchUserCards();
          console.log('err', err);
        });
    })
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  onClickDelete = (event, cardId) => {
    event.preventDefault();
    const options = {
      title: this.t('content.account.card.deleteCard'),
      message: this.t('content.account.card.deleteCardMessage'),
      willUnmount: () => { },
      customUI: ({ title, message, onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <div className='react-confirm-header'>
              <FontAwesomeIcon
                icon={['far', 'frown']}
                size="2x"
              />
              <h1 dangerouslySetInnerHTML={{ __html: title }} />
            </div>

            <div className='react-confirm-desc'>
              <p>{message}</p>
            </div>

            <div className='react-confirm-alert-button-group'>
              <button
                onClick={() => { this.removeCard(cardId); onClose(); }}
                className="button btn-remove"
              >
                {this.t('content.account.card.removeBtnConfirm')}
              </button>
              <button onClick={onClose} className="button btn-cancel">
                {this.t('content.account.card.removeBtnCancel')}
              </button>
            </div>

            <button onClick={onClose} title="Close" className="react-confirm-close">
              <FontAwesomeIcon
                icon={['fas', 'times']}
                size="2x"
              />
            </button>
          </div>
        )
      }
    };
    confirmAlert(options);
  }

  render() {
    const { defaultState, isLoading } = this.state;

    if (!this.props.isLogged && !this.props.isMyAccount) {
      this.props.handleShowForm();
    }

    if (this.props.isLogged && isLoading) {
      return (
        <div style={{ height: '94px' }}>
          <i className="loader" />
        </div>
      )
    }

    return (
      <Fragment>
        {(!this.props.isMyAccount && this.state.customerCards.length > 0) &&
          <label><T>content.account.card.chooseCard</T></label>
        }

        {(this.props.isMyAccount && this.state.customerCards.length == 0) &&
          <div className="message message--info">
            <p><T>content.account.card.emptyCardsList</T></p>
          </div>
        }

        {this.props.isLogged &&
          <ul className="list-cards">
            {this.state.customerCards.map((el, i) => {
              return (
                <ListItem
                  isMyAccount={this.props.isMyAccount}
                  key={i}
                  index={i}
                  brand={el.card.brand}
                  number={el.card.last4}
                  isActive={this.props.selectedCardId === el.id}
                  onClick={this.handleClick}
                  defaultState={defaultState}
                  id={el.id}
                  onClickDelete={this.onClickDelete}
                />
              );
            })}

            {(this.props.isLogged && !this.props.isMyAccount) &&
              <li className="list-cards__item list-cards__item--add-card">
                <button className="button--add-card" onClick={this.props.handleShowForm}>
                  <span>
                    <FontAwesomeIcon
                      icon={['fas', 'plus']}
                      size="1x"
                    />
                  </span>
                  <T>content.account.card.addNewCardButton</T>
                </button>
              </li>
            }
          </ul>
        }
      </Fragment>
    )
  };
}

class ListItem extends React.Component {

  handleClick = () => {
    this.props.onClick(this.props.id);
  };

  renderCardImage() {
    const brand = _.toLower(this.props.brand);
    switch (brand) {
      case "visa":
        var src = visa;
        break;
      case "mastercard":
        var src = mastercard;
        break;
      default:
        var src = visa;
    }
    return (
      <img src={src} alt={brand} className="list-card__logo" />
    );
  }

  render() {
    const { id, number, isActive, isMyAccount } = this.props;
    const listItemClasses = classNames('list-cards__item', {
      'list-cards__item--active': isActive,
      // if is my account dont disable cards
      'list-cards__item--disabled': (isMyAccount ? false : !isActive)
    });

    return (
      <li
        className={listItemClasses}
        onClick={this.handleClick}
      >
        {this.renderCardImage()}
        <p className="list-card__nr">**** **** **** {number}</p>
        <button
          className="button--icon"
          title="Delete card"
          onClick={(e) => this.props.onClickDelete(e, id)}
        >
          <FontAwesomeIcon
            icon={['fas', 'trash-alt']}
            size="lg"
          />
        </button>
      </li>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    locale: state.app.locale,
  };
};

export default connect(
  mapStateToProps,
  { createSuccessNotification, createErrorNotification },
  null,
  { withRef: true }
)(CardItems);
